import StoreModuleService from '../../modules/StoreModuleService';
import WidgetFieldService from '@/components/BlockEditorWidget/WidgetFieldService';

/**
 * IMPORTANT TO ANYONE WHO ADD / CHANGE / REMOVE ANY ACTION HERE
 * ANY CHANGES TO THE GETTERS LIST NEEDS TO BE REFLECTED IN
 * 'WidgetEditor', 'generalConfigurationWidgetEditor' and 'userConfigurationWidgetEditor
 * and any other if new one is added
 */

export const getGettersDeclarations = (moduleName) => {
	const buildWidgetEditorGetterObject = (getter) => StoreModuleService.buildGetterObject(moduleName, getter);
	// getters declarations
	const widget = buildWidgetEditorGetterObject('widget');
	const widgetId = buildWidgetEditorGetterObject('widgetId');
	const widgetWorkflowVersionId = buildWidgetEditorGetterObject('widgetWorkflowVersionId');
	const widgetNodeId = buildWidgetEditorGetterObject('widgetNodeId');
	const editField = buildWidgetEditorGetterObject('editField');
	const widgetTitle = buildWidgetEditorGetterObject('widgetTitle');
	const widgetFields = buildWidgetEditorGetterObject('widgetFields');
	const footerField = buildWidgetEditorGetterObject('footerField');
	const isSavingWidget = buildWidgetEditorGetterObject('isSavingWidget');
	const isLoadingWidgetFields = buildWidgetEditorGetterObject('isLoadingWidgetFields');
	const widgetMetadata = buildWidgetEditorGetterObject('widgetMetadata');
	const widgetFieldCredentials = buildWidgetEditorGetterObject('widgetFieldCredentials');

	const declarations = {
		widget,
		widgetId,
		widgetWorkflowVersionId,
		editField,
		widgetTitle,
		widgetFields,
		footerField,
		isSavingWidget,
		isLoadingWidgetFields,
		widgetMetadata,
		widgetFieldCredentials,
		widgetNodeId,
	};

	return declarations;
};

export const buildGetters = (moduleName) => {
	const {
		widget,
		widgetId,
		editField,
		widgetTitle,
		widgetFields,
		footerField,
		isSavingWidget,
		isLoadingWidgetFields,
		widgetMetadata,
		widgetFieldCredentials,
		widgetNodeId,
		widgetWorkflowVersionId,
	} = getGettersDeclarations(moduleName);

	const getters = {
		[widget.getter]: (state) => state.widget,
		[widgetId.getter]: (state) => state.widget?.id,
		[editField.getter]: (state) => state.editField,
		[widgetTitle.getter]: (state) => state.widgetTitle,
		[widgetFields.getter]: (state) => state.widget?.fields || [],
		[footerField.getter]: (state) => WidgetFieldService.getWidgetFooterField(state.widget?.fields || []),
		[widgetMetadata.getter]: (state) => state.widgetMetadata || {},
		[isSavingWidget.getter]: (state) => state.isSavingWidget,
		[isLoadingWidgetFields.getter]: (state) => state.isLoadingWidgetFields,
		[widgetFieldCredentials.getter]: (state) => (widgetFieldId) => {
			if (!state.widget?.fields || !Array.isArray(state.widget?.fields)) {
				return null;
			}
			const field = state.widget.fields.find((f) => f.id == widgetFieldId);
			return field?.metadata?.source?.credentials;
		},
		[widgetNodeId.getter]: (state) => state.nodeId,
		[widgetWorkflowVersionId.getter]: (state) => state.workflowVersionId,
	};

	return getters;
};
